import React, { useState } from 'react'
import { TableRow, TableCell, Button } from '@mui/material'
import { UserActiveStatusDialog } from './UserActiveStatusDialog'

export const UserRow = (props) => {
  const { row } = props

  //handle close for activate/deactivate dialog
  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
        <TableCell scope='row'>{row.email}</TableCell>
        <TableCell align='right'>{row.name}</TableCell>
        <TableCell align='right'>{row.lastName}</TableCell>
        <TableCell align='right'>{row.officialName}</TableCell>
        <TableCell align='right'>{row.employeeId}</TableCell>
        <TableCell align='right'>{row.position}</TableCell>
        <TableCell align='right'>
          <Button
            component='a'
            href={`/edit-user?id=${row._id}`}
            variant='contained'
            color='primary'
            size='small'
          >
            Edit
          </Button>
        </TableCell>
        <TableCell align='right'>
          {!row.active ? (
            <Button
              variant='contained'
              color='primary'
              size='small'
              style={{ width: '100px' }}
              onClick={() => setOpen(!open)}
            >
              Activate
            </Button>
          ) : (
            <Button variant='outlined' size='small' onClick={() => setOpen(!open)}>
              Deactivate
            </Button>
          )}
        </TableCell>
      </TableRow>
      <UserActiveStatusDialog onClose={handleClose} open={open} row={row} />
    </>
  )
}
